import React, { useEffect } from 'react';
import { useUser } from '@gadgetinc/react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import { hasAnyRole, isInstitutionAdministrator } from '../lib/roleUtils';

const RequireSignedInRole = ({ children, role }) => {
  const navigate = useNavigate();
  const user = useUser(api);

  // Normalize role to always be an array
  const requiredRoles = (Array.isArray(role) ? role : [role]).filter(Boolean);
  const roleSource = user?.roles || user?.roleList || [];
  const requiresAdminRole = requiredRoles.some((requiredRole) => {
    const normalized = String(requiredRole || "").trim().toLowerCase();
    return normalized === "admin" || normalized === "system-admin" || normalized === "sysadmin";
  });
  const hasRequiredRole = !!user && (
    hasAnyRole(roleSource, requiredRoles) ||
    (requiresAdminRole && isInstitutionAdministrator(user))
  );

  useEffect(() => {
    // If user is null (unauthenticated), redirect to home
    if (user === null) {
      navigate('/');
      return;
    }

    // If user exists, check if they have any of the required roles
    if (user && !hasRequiredRole) {
      console.log('RequireSignedInRole: User does not have required role');
      console.log('User roles:', user.roles);
      console.log('Required roles:', requiredRoles);
      navigate('/');
      return;
    }
  }, [user, navigate, requiredRoles, hasRequiredRole]);

  // If user is null (unauthenticated), don't render anything while redirecting
  if (user === null) {
    return null;
  }

  if (!user) {
    return null;
  }

  if (!hasRequiredRole) {
    return null;
  }

  return children;
};

export default RequireSignedInRole;
